module.exports = __webpack_public_path__ + "static/media/img-msg-secret.a2f282ad.png";